import useWebData from '../../hooks/useWebData';
import { baseURL } from '../../config/api';
import useVehicleEnquiry from '../../hooks/useVehicleEnquiry';
import { iconValues } from '../../utils/iconValues';

type Props = {
    availableVehicle: any[];
    setSelectedVehicleClass: (value: any) => void;
    selectedVehicleClass: any;
    getDataFromCars: (vehicleId: string, selectedVehicleClass: any) => void;
    setCurrentPage: () => void;
    reservation: any;
}

const Cars = ({
    availableVehicle,
    setSelectedVehicleClass,
    selectedVehicleClass,
    getDataFromCars,
    setCurrentPage,
    reservation
}: Props) => {
    const { webData }: any = useWebData();
    const { setOpen, setVehicleClassId }: any = useVehicleEnquiry();


    return (
        <div className="w-full flex flex-col md:p-6">
            {selectedVehicleClass && (
                <div className="mb-4">
                    <span className="text-sm font-semibold">Selected Vehicle</span>

                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 bg-transparent p-4 mt-2 w-full rounded-lg shadow-sm border">
                        {/* Image */}
                        <img
                            src={
                                selectedVehicleClass?.imagePath.startsWith("data:image")
                                    ? selectedVehicleClass?.imagePath
                                    : `${baseURL}vehicleClassFile/Get?name=` + selectedVehicleClass?.imagePath
                            }
                            alt="vehicle"
                            className="w-full md:w-[230px] rounded-md object-cover"
                        />

                        {/* Info */}
                        <div className="flex-1 flex flex-col gap-1.5 px-0 md:px-2">
                            <span className="text-base font-semibold">{selectedVehicleClass?.vehicleLabel}</span>

                            <div className="flex flex-wrap gap-1.5 text-xs">
                                {selectedVehicleClass?.features
                                    ?.sort((a: any, b: any) => a.order - b.order)
                                    ?.map((feature: any, i: number) => {
                                        const iconData = iconValues?.find((icon) => icon?.value === feature?.icon);

                                        return (
                                            <div
                                                key={i}
                                                className={`flex items-center gap-1 text-xs text-black-rgba`}
                                            >
                                                {
                                                    iconData && (
                                                        <span className={`material-symbols-outlined text-[16px]`}>{iconData?.icon}</span>
                                                    )
                                                }
                                                <span>{feature?.websiteLabel}</span>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>

                        {/* Price */}
                        <div className="flex flex-col gap-1.5 text-left w-full md:w-[25%]">
                            {selectedVehicleClass?.recommended && (
                                <div className="flex justify-end">
                                    <span className="inline-block text-xs px-3 py-1 rounded-xl font-semibold bg-[#D9F4D4] text-[#039855] border">
                                        Recommended
                                    </span>
                                </div>
                            )}
                            <p className="text-sm font-semibold">${parseFloat(selectedVehicleClass?.dailyRate)?.toFixed(2)} <span className="font-normal">/Day</span></p>
                            <p className="text-sm font-semibold">
                                ${Number(reservation?.totalBasePriceBeforeDiscount)?.toFixed(2)} total for {selectedVehicleClass?.days} Day
                                {selectedVehicleClass?.hours !== 0 && ` and ${selectedVehicleClass?.hours} hours`}
                            </p>
                            <p className="text-xs font-normal">Excl. taxes & insurance(s)</p>
                        </div>
                    </div>
                </div>
            )}

            {/* Vehicle List Heading */}
            <span className="font-bold text-lg">
                {selectedVehicleClass ? "Select Other Vehicle" : "Available Vehicle"}
            </span>
            <hr
                style={{ background: webData?.websiteHeaderColor }}
                className="w-full h-1 mb-4"
            />

            {/* Available Vehicles */}
            {availableVehicle?.map((item: any, index: number) => (
                <div key={index} className="mt-4">
                    <div
                        className={`
    flex flex-col md:flex-row md:items-center justify-between gap-4 p-4 w-full rounded-lg shadow-sm border transition
  `}
                    >
                        {/* Image */}
                        <img
                            src={
                                item?.imagePath?.startsWith("data:image")
                                    ? item.imagePath
                                    : `${baseURL}vehicleClassFile/Get?name=` + item?.imagePath
                            }
                            alt="vehicle"
                            className="w-full md:w-[230px] rounded-md object-cover"
                        />

                        {/* Info */}
                        <div className="flex-1 flex flex-col gap-1.5 px-0 md:px-2">
                            <span className="text-base font-semibold">{item?.vehicleLabel}</span>
                            <div className="flex flex-wrap gap-1.5 text-xs">
                                {item?.features
                                    ?.sort((a: any, b: any) => a.order - b.order)
                                    ?.map((feature: any, i: number) => {
                                        const iconData = iconValues?.find((icon) => icon?.value === feature?.icon);
                                        return (
                                            <div
                                                key={i}
                                                className={`flex items-center gap-1 text-xs text-black-rgba`}
                                            >
                                                {
                                                    iconData && (
                                                        <span className={`material-symbols-outlined text-[16px]`}>{iconData?.icon}</span>
                                                    )
                                                }
                                                <span>{feature?.websiteLabel}</span>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>

                        {/* Pricing */}
                        <div className="flex flex-col gap-1.5 text-left w-full md:w-[25%]">
                            {item?.availableVehicles > 0 && item?.recommended && (
                                <div className="flex justify-end">
                                    <span className="inline-block text-xs px-3 py-1 rounded-xl font-semibold bg-[#D9F4D4] text-[#039855] border">
                                        Recommended
                                    </span>
                                </div>
                            )}

                            <p className="text-sm font-semibold">
                                ${parseFloat(item?.dailyRate).toFixed(2)} <span className="font-normal">/Day</span>
                            </p>

                            <p className="text-sm font-semibold">
                                ${parseFloat(item?.days) >= 30
                                    ? (
                                        parseInt((parseInt(item?.days) / 30)?.toFixed(0)) *
                                        Number(item?.monthilyRate) +
                                        parseInt(parseInt((parseInt(item?.days) % 30) + "") / 7 + "") *
                                        Number(item?.weeklyRate) +
                                        parseInt(((parseInt(item?.days) % 30) % 7)?.toFixed(0)) *
                                        Number(item?.dailyRate) +
                                        parseFloat(item?.hours) * Number(item?.hourlyRate)
                                    )?.toFixed(2)
                                    : parseFloat(item?.days) >= 7
                                        ? (
                                            parseInt((parseInt(item?.days) / 7)?.toFixed(0)) *
                                            Number(item?.weeklyRate) +
                                            parseInt((parseInt(item?.days) % 7)?.toFixed(0)) *
                                            Number(item?.dailyRate) +
                                            parseFloat(item?.hours) * Number(item?.hourlyRate)
                                        )?.toFixed(2)
                                        : (
                                            parseFloat(item?.days) * Number(item?.dailyRate) +
                                            parseFloat(item?.hours) * Number(item?.hourlyRate)
                                        )?.toFixed(2)}{" "}
                                total for {item?.days} Day{item?.hours !== 0 && ` and ${item?.hours} hours`}
                            </p>

                            <p className="text-xs font-normal">Excl. taxes & insurance(s)</p>

                            <button
                                className={`
        w-full text-white font-semibold px-2 py-2 rounded text-xs
      `}
                                style={{
                                    backgroundColor:
                                        item?.availableVehicles <= 0
                                            ? "#D92D20"
                                            : webData?.websiteHeaderColor,
                                }}

                                onClick={() => {
                                    if (item?.availableVehicles > 0) {
                                        setSelectedVehicleClass(item);
                                        getDataFromCars(item?.vehicleClassId, item);
                                        setCurrentPage();
                                    } else {
                                        setVehicleClassId(item?.vehicleClassId);
                                        setOpen(true);
                                    }
                                }}
                            >
                                {item?.availableVehicles <= 0 ? "Not Available - Contact Us" : "Select"}
                            </button>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Cars